import {
  initialize as initializeConsentConfiguration,
  cleanup as cleanupConsentConfiguration,
} from "./views/settings/consent_configuration";

export const initialize = initializeConsentConfiguration;
export const cleanup = cleanupConsentConfiguration;
